var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bar_nav"},[_c('div',{staticClass:"title"},[_vm._v("关于我们")]),_c('div',{staticClass:"bar_back_btn",on:{"click":_vm.goToUserSetting}},[_vm._v("我")])]),_c('div',{staticClass:"bar_empty"})])}
var staticRenderFns = []

export { render, staticRenderFns }